<template>
  <div
    v-if="shouldShow"
    class="maintenance-banner text-dark p-3 text-center position-relative"
  >
    <strong class="mb-1 d-flex align-items-center justify-content-center">
      <BaseIcon
        icon="exclamation-triangle"
        tag="i"
        :font-scale="1.2"
        class="mr-2 flex-grow-0"
      />
      <span>{{ banner.title }}</span>
    </strong>

    <!-- Message from DB via API -->
    {{ banner.message }}

    <!-- Close / dismiss -->
    <a
      role="button"
      class="text-white mt-2 mr-1 position-absolute top-0 right-0 close"
      @click.prevent="close"
      title="Dismiss"
    >
      <BaseIcon icon="x-circle-fill" tag="i" />
    </a>
  </div>
</template>

<script>


import {
  defineComponent,
  computed,
  ref,
  onBeforeMount
} from '@vue/composition-api'


import { BaseIcon } from '@components/base'
import axios from '@/util/axios'


export default defineComponent({
  name: "MaintenanceBanner",
  components: { BaseIcon },
  props: {
    bannerData: {
      type: Object,
      default: null
    }
  },
  setup(props) {
    const LOCAL_STORAGE_KEY = "LQ_ShowMaintenanceBanner";
    const BANNER_ENDPOINT = "/maintenance-banner/";

    // Use prop if provided, otherwise default
    const banner = ref(props.bannerData || {
      enabled: false,
      message: "",
      start_date: null,
      end_date: null,
      timezone: "CT",
    });

    const loading = ref(false);
    const error = ref(false);
    const isClosed = ref(false);

    const close = () => {
      sessionStorage.setItem(LOCAL_STORAGE_KEY, "1");
      isClosed.value = true;
    };

    const shouldShow = computed(() => {
      if (loading.value) return false;
      if (error.value) return false;
      if (!banner.value.enabled) return false;
      if (isClosed.value) return false;
      return true;
    });

    const loadBanner = async () => {
      if (props.bannerData) return; // Don't fetch if prop is provided
      loading.value = true;
      error.value = false;
      try {
        const res = await axios.get(BANNER_ENDPOINT, {
          withCredentials: true,
        });
        const data = res.data.data || res.data;
        banner.value = {
          enabled: data.enabled === true,
          title: data.title || "",
          message: data.message || "",
          start_date: data.start_date || null,
          end_date: data.end_date || null,
          timezone: data.timezone || "CT",
        };
      } catch (e) {
        error.value = true;
        banner.value.enabled = false;
      } finally {
        loading.value = false;
      }
    };

    onBeforeMount(async () => {
      isClosed.value = sessionStorage.getItem(LOCAL_STORAGE_KEY) === "1";
      await loadBanner();
    });

    return {
      banner,
      shouldShow,
      close,
    };
  },
});
</script>

<style scoped>
.maintenance-banner {
  background-color: #ff7900;
  line-height: 1.2;
}

.maintenance-banner .close {
  font-size: 1.2rem;
  float: none;
}
</style>
